import { render, staticRenderFns } from "./ArticleContentStep.vue?vue&type=template&id=4df8117d&scoped=true&"
import script from "./ArticleContentStep.vue?vue&type=script&lang=js&"
export * from "./ArticleContentStep.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContentStep.vue?vue&type=style&index=0&id=4df8117d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8117d",
  null
  
)

export default component.exports